import { parseServerInstant } from '../../Dashboard/core/mskTime'

const mskTime = new Intl.DateTimeFormat('ru-RU', {
  timeZone: 'Europe/Moscow',
  day: '2-digit',
  month: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
})

/** Сумма без копеек, если их нет, с разрядами. */
export const money = (v: number | null | undefined): string =>
  v === null || v === undefined ? '—' : v.toLocaleString('ru-RU', { maximumFractionDigits: 2 })

/** Момент по МСК в коротком виде «14.09, 12:30». */
export const shortMsk = (raw: string | null | undefined): string =>
  raw ? mskTime.format(parseServerInstant(raw)) : '—'

/** Длительность «2 ч 15 мин» / «40 мин». */
export const duration = (ms: number): string => {
  const minutes = Math.max(0, Math.round(ms / 60000))
  const h = Math.floor(minutes / 60)
  const m = minutes % 60
  if (h === 0) return `${m} мин`
  return m === 0 ? `${h} ч` : `${h} ч ${m} мин`
}

/** Часы конфига: дробные показываются минутами, чтобы 1.5 не читалось как «1,5 ч». */
export const hours = (h: number | null | undefined): string =>
  h === null || h === undefined ? '—' : duration(h * 3600000)
